import { render } from "./cfImageshow.vue?vue&type=template&id=2a5cd4ce&ts=true"
import script from "./cfImageshow.vue?vue&type=script&lang=ts"
export * from "./cfImageshow.vue?vue&type=script&lang=ts"

import "./cfImageshow.vue?vue&type=style&index=0&id=2a5cd4ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__